module.exports = __webpack_public_path__ + "img/7.a040b385.png";